import { render, staticRenderFns } from "./DocumentFilter.vue?vue&type=template&id=d88ee1e6&scoped=true"
import script from "./DocumentFilter.vue?vue&type=script&lang=js"
export * from "./DocumentFilter.vue?vue&type=script&lang=js"
import style0 from "./DocumentFilter.vue?vue&type=style&index=0&id=d88ee1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88ee1e6",
  null
  
)

export default component.exports